import React from "react";
import AutosizeTextarea from "../AutosizeTextarea";

const DashboardInput = ({ value, handleChange, editing }) => {
  const [focused, setFocused] = React.useState(false);
  return (
    <AutosizeTextarea
      // classnames="Profile-txtarea textarea-input dashboard"
      value={value}
      handleChange={handleChange}
      setFocused={setFocused}
      initialRows={1}
      editing={editing}
    />
  );
};

export default DashboardInput;
